import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useHelpLinkFeature } from "../../../composables";


export default /*@__PURE__*/_defineComponent({
  __name: 'HelpBtn',
  props: {
    link: {},
    label: {},
    icon: {},
    disable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const { isLinkExternal, onHelpLinkClick } = useHelpLinkFeature();

const onClickToInstruction = () => {
  if (isLinkExternal(props.link)) {
    window.open(props.link, "_blank");
  } else {
    onHelpLinkClick(props.link);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_d_btn = _resolveComponent("d-btn")!

  return (_openBlock(), _createBlock(_component_d_btn, {
    variant: "secondary",
    onClick: onClickToInstruction,
    label: _ctx.label,
    icon: _ctx.icon,
    disable: _ctx.disable
  }, null, 8, ["label", "icon", "disable"]))
}
}

})